import gql from 'graphql-tag';
import React from 'react';
import { CheckoutCreditCardSummaryFields } from '../schemas/rql';
import CheckoutVerifyCardCVV from './checkout_verify_card_cvv';
import CreditCardBrandIcon from './credit_card_brand_icon';

type CreditCard = CheckoutCreditCardSummaryFields.CreditCard;

interface Props {
  creditCard: CreditCard;
}

export default function CheckoutCreditCardSummary({ creditCard }: Props) {
  return (
    <div>
      <div className="d-flex">
        <div style={{ width: '5rem' }}>
          <CreditCardBrandIcon
            brand={creditCard.brand}
          />
        </div>
        <div className="pl-1">
          <div className="weight-bold">
            {creditCard.display.summary}
          </div>
          <div className="size-80">
            {creditCard.display.expirationDate}
          </div>
        </div>
      </div>
      <div>
        {creditCard.needsReverification &&
          <div className="mt-space">
            <CheckoutVerifyCardCVV
              creditCard={creditCard}
              hasRefetch
            />
          </div>
        }
      </div>
    </div>
  );
}

export const CheckoutCreditCardSummaryFragment = gql`
  fragment CheckoutCreditCardSummaryFields on Checkout {
    _id
    creditCard {
      needsReverification
      cardType
      brand {
        type
        name
      }
      display {
        summary
        expirationDate
      }
    }
  }
`;
